/* @flow */

/**
 * @description Global Param passed from web properties
 * @module globalParams
 * @exports globalParams
 */

import { extend } from './utils/coreutils';

/**
 * @global
 * @typedef siteInfo
 * @property {string} site Site name
 * @property {string} brand UOL brand
 * @property {string} uid User ID
 * @property {string} sLevel User service level
 */

/**
 * @global
 * @typedef gpAdConfig
 * @property {string} url Ad Config URL
 * @property {number} loadTimeout Ad config load timeout
 * @property {object} override Override for global config
 */

/**
 * @global
 * @typedef gpPageInfo
 * @property {string|Array<string>|Function} posList List of ad positions
 * @property {string|Function} name Page name
 */

/**
 *
 * @typedef  globalParams
 * @global
 * @type {object}
 * @property {siteInfo} phInfo Phoenix Info object
 * @property {gpAdConfig} adConfig Ad Config info
 * @property {gpPageInfo} pageInfo pageInfo config
 * @property {string} [iframeHolder] Extra IFRAME id to check for ad placements
 * @property {object} [customVars] Custom variables to pass to ad server/advertisers
 * @property {object} [QPVars] Query params for Ad Servers
 * @property {string} adPage Ad Page path to load in IFRAME
 * @property {boolean} [isDialup=false] Dial-up User?
 * @property {string} [sWrapper=Wrap] Wrapper Div ID suffix for ad placements
 */
const _gParams = {
  // user specific details
  phInfo: {
    site: '',
    brand: '',
    uid: '',
    sLevel: ''
  },

  // adconfig related params
  adConfig: {
    loadTimeout: 15000,
    url: '//static.uolcontent.com/cgi/aconfig',
    override: {}
  },

  // per page information
  // sites can provide default value for these as global params
  // Or they can provide callback function
  // Or they can pass them along with _getAds
  pageInfo: {
    posList: '',
    name: ''
  },

  // static template used for loading ad iframes (not used for old IE browsers)
  adPage: '',

  // custom variables will be available as global variables inside ad iframe
  customVars: {},

  // query params passed to adserver
  QPVars: {},

  // used for page where parent page loads content inside iframe and ads needs to be loaded inside this iframe
  // iframe 'id' should be passed here and additional ad iframe will be created inside the parent iframe.
  iframeHolder: '',

  // whether user is in dialup or not
  isDialup: false,

  // WrapperDivPostfix
  sWrapper: 'Wrap'
};

const globalParams = {
  ValidateAndUpdateConfig: (gParams: globalParam): boolean => {
    if (gParams === undefined) {
      return false;
    }

    // merge default values in globalParams with input
    extend(true, _gParams, gParams);

    // check for non-default global params
    if (_gParams.phInfo.site === '') {
      return false;
    }
    return true;
  },

  get: (): globalParam => _gParams
};

export default globalParams;
